import Vue from 'vue';
import _ from "lodash";
import webStorage from "@/libs/webStorage";

const types = {
  LOADING: 'LOADING',
  SET_FIELD: 'SET_FIELD',
  ADD_DEFAULT_CODE: 'ADD_DEFAULT_CODE',
  SET_DEFAULT_CODE_MANUAL: 'SET_DEFAULT_CODE_MANUAL',
  ADD_DEFAULT_LOCALE: 'ADD_DEFAULT_LOCALE',
  SET_LOCALE: 'SET_LOCALE',
  ADD_ERROR: 'ADD_ERROR',
};

const localeCurrent = webStorage.get('LOCALE');

// initial state
const initalState = {
  langs: [{
    value: 'en',
    text: 'English'
  },
  {
    value: 'vi',
    text: 'Tiếng Việt'
  }],
  form: {},
  error: {},
  loading: false,
  defaultCode: '',
  defaultLocale: localeCurrent ? localeCurrent : 'vi',
};

// getters
const getters = {
  langs: state => state.langs,
  form: state => state.form,
  loading: state => state.loading,
  error: state => state.error,
  defaultCode: state => state.defaultCode,
  defaultLocale: state => state.defaultLocale,
};

// actions
const actions = {
  setField({ commit, dispatch }, { key, value, type }) {
    commit(types.SET_FIELD, { key, value, type });
  },

  setDefaultCode({ commit }, code) {
    webStorage.set("CODE_DEFAULT", code);
    commit(types.ADD_DEFAULT_CODE, code);
  },
  
  setDefaultCodeManual({ commit }, code) {
    webStorage.set("SET_DEFAULT_CODE_MANUAL", code);
    commit(types.ADD_DEFAULT_CODE, code);
  },
  
  setLocale({ commit }, lang) {
    webStorage.set("LOCALE", lang);
    setTimeout(_ => {
      location.reload();
    }, 500)
  },

  getDefaultLocale({ commit }) {
    commit(types.ADD_DEFAULT_LOCALE, webStorage.get("LOCALE"));
  },

  getDefaultCode({ commit }) {
    commit(types.ADD_DEFAULT_CODE, webStorage.get("CODE_DEFAULT"));
  },
  
  clearDefaultCode({ commit }) {
    webStorage.set("CODE_DEFAULT", '');
  },
};

// mutations
const mutations = {
  [types.SET_FIELD](state, params) {
    Vue.set(state.form, params.type, params.value);
  },

  [types.LOADING](state, loading) {
    Vue.set(state, 'loading', loading);
  },

  [types.ADD_DEFAULT_CODE](state, code) {
    Vue.set(state, 'defaultCode', code);
  },
  
  [types.SET_DEFAULT_CODE_MANUAL](state, code) {
    Vue.set(state, 'defaultCode', code);
  },

  [types.ADD_DEFAULT_LOCALE](state, lang) {
    Vue.set(state, 'defaultLocale', lang);
  },

  [types.ADD_ERROR](state, errors) {
    Vue.set(state, "error", {
      ...state.error,
      ...errors
    });
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
